"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HeaderStrip() {
  const { t } = useLanguage();

  return (
    <div className="bg-[#047857] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        <nav className="flex items-center gap-2 text-sm">
          <Link to="/" className="hover:text-[#fefce8] transition-colors">
            {t("nav.home")}
          </Link>
          <span className="text-white/60">&gt;</span>
          <span className="text-white/90">{t("nav.services")}</span>
          <span className="text-white/60">&gt;</span>
          <span className="text-white/90">{t("sliding.breadcrumbName")}</span>
        </nav>
        <span className="text-sm font-medium">{t("common.sameDay")}</span>
      </div>
    </div>
  );
}